module.exports = __webpack_public_path__ + "media/honey-icons/icon-refer-a-friend-8c76725a.svg";